module.exports = __webpack_public_path__ + "static/media/businesssupport.bd030ae2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/businesssupport.svg
// module id = 153
// module chunks = 0